export const WELL_KNOWN_CONFIG = 'wellKnownConfig';
export const ISSUER = 'issuer';
export const VERIFIER = 'verifier';
export const STATE = 'state';
export const SESSION_STATE = 'session_state';
export const TOKEN_RESPONSE = 'tokenResponse';
